import axios from 'axios'


const getApiBaseUrl = () => {
  // Если запущено в production (Docker)
  if (process.env.NODE_ENV === 'production') {
    // Используем относительный путь - nginx проксирует на backend
    return ''
  }
  
  // Для разработки
  return process.env.VUE_APP_API_URL || 'https://azarov-team-pay.ru'
}

const API_BASE_URL = getApiBaseUrl()
const DEBUG_API = process.env.NODE_ENV !== 'production' && process.env.VUE_APP_DEBUG_API === 'true'

export const PUBLIC_ROUTE_RULES = [
  { type: 'exact', path: '/' },
  { type: 'exact', path: '/login' },
  { type: 'exact', path: '/success' },
  { type: 'exact', path: '/privacy' },
  { type: 'exact', path: '/public-offer' },
  { type: 'exact', path: '/makeup' },
  { type: 'exact', path: '/registration' },
  { type: 'exact', path: '/child-selection' },
  { type: 'exact', path: '/event-additional-info' },
  { type: 'exact', path: '/additional-documents' },
  { type: 'prefix', path: '/event/' },
  { type: 'prefix', path: '/additional-documents/' }
]

export const isPublicRoutePath = (pathname = '/') => {
  const normalizedPath = pathname || '/'

  return PUBLIC_ROUTE_RULES.some((rule) => {
    if (rule.type === 'exact') {
      return normalizedPath === rule.path
    }

    return normalizedPath === rule.path || normalizedPath.startsWith(rule.path)
  })
}

export const shouldRedirectUnauthorized = (pathname = '/') => {
  return pathname !== '/login' && !isPublicRoutePath(pathname)
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // Увеличиваем timeout
  headers: {
    'Content-Type': 'application/json',
  }
})

// Interceptor для добавления токена из localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (DEBUG_API) {
      console.log('API Request:', config.method?.toUpperCase(), config.url)
    }
    return config
  },
  (error) => {
    if (DEBUG_API) {
      console.error('Request Error:', error)
    }
    return Promise.reject(error)
  }
)

// Interceptor для обработки ошибок авторизации
api.interceptors.response.use(
  (response) => {
    if (DEBUG_API) {
      console.log('API Response:', response.status, response.config.url)
    }
    return response
  },
  (error) => {
    if (DEBUG_API) {
      console.error('API Error:', error.response?.status, error.response?.data || error.message)
    }
    
    if (error.response?.status === 401) {
      // Если получили 401, очищаем токен и перенаправляем на логин
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete api.defaults.headers.common['Authorization']
      
      // На публичных маршрутах показываем локальную ошибку вместо перехода в админский логин.
      if (shouldRedirectUnauthorized(window.location.pathname)) {
        window.location.href = '/login'
      }
    }
    
    return Promise.reject(error)
  }
)

export default api
